<template>
  <div id="app">
    <GmapMap :center="center" :zoom="10" id="google-map-div" map-style-id="roadmap" :options="mapOptions"
      style="width: 100%; height: 250px" ref="mapRef" @click="handleMapClick">
      <GmapMarker :position="marker.position" :clickable="true" :draggable="true" @drag="handleMarkerDrag"
        @click="panToMarker" />
      <GmapCluster>
        <GmapMarker v-for="(loc, index) in markerLocations" :key="index" :position="{ lat: loc.lat, lng: loc.lng }"
          @click="toggleInfoWindow(loc)" />
      </GmapCluster>
    </GmapMap>
  </div>
</template>
<script>
export default {
  props: {
    marker: {
      type: Object,
      default() {
        return { position: { lat: 24.7136, lng: 46.6753 } };
      },
    },
    center: {
      type: Object,
      default() {
        return { lat: 24.7136, lng: 46.6753 };
      },
    },
    ["markerLocations"]: {
      type: Array,
    },
    ["customHeight"]: {
      type: Number,
    },
  },

  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
      },
    };
  },
  mounted() {
    if (this.customHeight != null) {
      document.getElementById("google-map-div").style.height =
        this.customHeight + "px";
    }

  },
  methods: {
    toggleInfoWindow(marker) {
      console.log(marker)
      if (marker.user) {
        let routeData = this.$router.resolve({ name: "DriverDetails", params: { id: marker.user } });
        window.open(routeData.href, '_blank');
      }
    },
    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        this.panToMarker();
      });
      this.positionChanged();
    },

    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    },

    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
      this.$refs.mapRef.setZoom(18);
      this.positionChanged();
    },

    //Moves the marker to click position on the map
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.positionChanged();
    },
    positionChanged() {
      this.$emit("locationChange", this.marker.position);
    },
  },
};
</script>

<style>
</style>
